import { parameterize } from "@uenf/layout";

const routes = {
  centrosPath: (centroId) => `${RELATIVE_URL_PATH}/centros/${centroId}/setores`,
  aceitarRequisicoesDisponibilidadesPath: (params) => `${RELATIVE_URL_PATH}/disponibilidades?${parameterize(params)}`,
};

export { routes };
